(function () {
    const normalizeTag = function (value) {
        return (value || '').trim().toLowerCase();
    };

    const init = function () {
        const tagButtons = Array.from(document.querySelectorAll('[data-tag]'));

        if (tagButtons.length === 0) {
            return;
        }

        const cards = Array.from(document.querySelectorAll('[data-painting-card]'));
        const clearButtons = Array.from(document.querySelectorAll('[data-clear-filters]'));
        const filterCount = document.querySelector('[data-filter-count]');
        const emptyState = document.querySelector('[data-paintings-empty]');
        const allButton = tagButtons.find(function (button) {
            return normalizeTag(button.getAttribute('data-tag')) === '';
        }) || null;

        let activeTag = '';

        const formatCount = function (count) {
            return 'Viser ' + count + ' ' + (count === 1 ? 'maleri' : 'malerier');
        };

        const findButtonByTag = function (tag) {
            const normalizedTag = normalizeTag(tag);

            return tagButtons.find(function (button) {
                return normalizeTag(button.getAttribute('data-tag')) === normalizedTag;
            }) || null;
        };

        const updateUrl = function () {
            const url = new URL(window.location.href);

            if (activeTag) {
                const activeButton = findButtonByTag(activeTag);
                const buttonTag = activeButton ? (activeButton.getAttribute('data-tag') || '').trim() : activeTag;
                url.searchParams.set('tag', buttonTag);
                localStorage.setItem('selectedPaintingTag', buttonTag);
            } else {
                url.searchParams.delete('tag');
                localStorage.removeItem('selectedPaintingTag');
            }

            const search = url.searchParams.toString();
            const nextUrl = url.pathname + (search ? '?' + search : '') + url.hash;
            window.history.replaceState(window.history.state, '', nextUrl);
        };

        const updateFilterUI = function () {
            const hasFilters = activeTag !== '';
            let visibleCount = 0;

            for (const button of tagButtons) {
                const buttonTag = normalizeTag(button.getAttribute('data-tag'));
                const isActive = hasFilters ? buttonTag === activeTag : buttonTag === '';

                button.classList.toggle('tag-chip--active', isActive);
                button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            }

            for (const card of cards) {
                const tagValue = card.getAttribute('data-tags') || '';
                const cardTags = new Set(tagValue.split('|').map(normalizeTag).filter(Boolean));
                const isVisible = !hasFilters || cardTags.has(activeTag);

                card.hidden = !isVisible;

                if (isVisible) {
                    visibleCount += 1;
                }
            }

            for (const button of clearButtons) {
                button.hidden = !hasFilters;
            }

            if (filterCount) {
                filterCount.hidden = !hasFilters;
                filterCount.textContent = hasFilters ? formatCount(visibleCount) : '';
            }

            if (emptyState) {
                emptyState.hidden = visibleCount > 0;
            }
        };

        const applyTag = function (tag, options) {
            const normalizedTag = normalizeTag(tag);
            const nextButton = normalizedTag ? findButtonByTag(normalizedTag) : allButton;

            activeTag = nextButton ? normalizeTag(nextButton.getAttribute('data-tag')) : '';
            updateFilterUI();

            if (!options || options.updateUrl !== false) {
                updateUrl();
            }
        };

        for (const button of tagButtons) {
            button.addEventListener('click', function () {
                const buttonTag = normalizeTag(button.getAttribute('data-tag'));

                if (buttonTag === activeTag) {
                    return;
                }

                applyTag(buttonTag);
            });
        }

        for (const button of clearButtons) {
            button.addEventListener('click', function () {
                if (activeTag === '') {
                    return;
                }

                applyTag('');
            });
        }

        var urlTag = new URLSearchParams(window.location.search).get('tag');
        applyTag(urlTag !== null ? urlTag : (localStorage.getItem('selectedPaintingTag') || ''));
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
        return;
    }

    init();
})();
